import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-operativo',
  templateUrl: './operativo.component.html',
  styleUrls: ['./operativo.component.css']
})
export class OperativoComponent implements OnInit {

  constructor(
    private router:Router
  ) { }

  ngOnInit(): void {
  }

  IrOperativoChv(){
    this.router.navigate(['operativochv']);
  }

  IrOperativoFivi(){
    this.router.navigate(['operativofivi-mensual']);
  }

  IrOperativoFiviTrimestral(){
    this.router.navigate(['operativofivi-trimestral']);
  }

}
